import axios from 'axios';
import {
  GET_MUSIC_FILTER,
  GET_FILTERED_MUSIC,
  CLEAR_FILTERED_MUSIC,
  GET_ALBUM,
  CLEAR_MUSIC_DATA,
  GET_NEW_MUSIC,
  GET_LAST_MUSIC,
  GET_TOP_MUSIC,
  GET_RECOMMENDED_MUSIC,
} from '../constants';

export const getMusicFilterSuccess = response => ({
  type: GET_MUSIC_FILTER,
  response,
});

export const getMusicFilter = () => dispatch => (
  axios.get('/music/audiobook/filter')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMusicFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMusicFilterSuccess(data));
    })
);

export const getFilteredMusicSuccess = response => ({
  type: GET_FILTERED_MUSIC,
  response,
});

export const getFilteredMusic = (page = 1, genre = '', country = '', year = '', language = '') => dispatch => (
  axios.get(`/music/playlists?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== 0 && response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getFilteredMusicSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getFilteredMusicSuccess(data));
    })
);

export const clearFilteredMusic = () => ({
  type: CLEAR_FILTERED_MUSIC,
});

export const clearMusicData = () => ({
  type: CLEAR_MUSIC_DATA,
});

export const getAlbumSuccess = response => ({
  type: GET_ALBUM,
  response,
});

export const getAlbum = id => dispatch => (
  axios.get(`/music/playlist/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getAlbumSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getAlbumSuccess(data));
    })
);

export const getNewMusicSuccess = response => ({
  type: GET_NEW_MUSIC,
  response,
});

export const getNewMusic = (page = 1, size = 15) => dispatch => (
  axios.get(`/music/playlists?order=new&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getNewMusicSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getNewMusicSuccess(data));
    })
);


export const getLastMusicSuccess = response => ({
  type: GET_LAST_MUSIC,
  response,
});

export const getLastMusic = (page = 1, size = 15) => dispatch => (
  axios.get(`/music/playlists?order=last&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getLastMusicSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getLastMusicSuccess(data));
    })
);

export const getTopMusicSuccess = response => ({
  type: GET_TOP_MUSIC,
  response,
});

export const getTopMusic = (page = 1, size = 15) => dispatch => (
  axios.get(`/music/playlists?order=top&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getTopMusicSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTopMusicSuccess(data));
    })
);


export const getRecommendedMusicSuccess = response => ({
  type: GET_RECOMMENDED_MUSIC,
  response,
});

export const getRecommendedMusic = (page = 1, size = 15) => dispatch => (
  axios.get(`/music/playlists?order=recommend&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getRecommendedMusicSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getRecommendedMusicSuccess(data));
    })
);
